import React from 'react';

import styles from '../app-launcher.module.css';

const DOTS = Array.from({ length: 9 }, (_, i) => i);

export const LauncherDots = () => (
    <span className={styles.dotsGrid}>
        {DOTS.map(i => (
            <span key={i} className={styles.dot} />
        ))}
    </span>
);
